import { TextField, Typography } from "./MyCustomFile"
export const MyTextarea = ({ name, label, value, onChange, error, rows, helperText, style = false, disabled = false, status = false }) => {
    return (
        <>
            <TextField
                fullWidth
                variant="outlined"
                margin="dense"
                name={name}
                label={`${label}${status ? "*" : ""}`}
                value={value}
                onChange={onChange}
                error={Boolean(error)}
                multiline
                rows={rows || 3}
                style={style ? { width: 600 } : {}}
                disabled={disabled}
            />
            {error && (<Typography variant="body2" style={{ color: "red", fontSize: "10px", marginLeft: "0" }}>{helperText}</Typography>)}
        </>
    );
}